export default {
  title: {
    id: 'product_mobile_plans_title',
    defaultMessage: 'Mobile plan options',
  },
  prepaidPlanName: {
    id: 'product_prepaid_plan_name',
    defaultMessage: 'Prepaid plan',
  },
  planDescription1: {
    id: 'product_prepaid_plan_description1',
    defaultMessage: '25 GB of Warp 5G premium data including hotspot',
  },
  planDescription2: {
    id: 'product_prepaid_plan_description2',
    defaultMessage: 'Unlimited talk and text',
  },
  planTag: {
    id: 'product_prepaid_plan_provider',
    defaultMessage: 'US Mobile',
  },
  modalTrigger: {
    id: 'product_prepaid_plan_modalTrigger',
    defaultMessage: 'What’s included',
  },
}
